"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.convertCurrency = void 0;
const convertCurrency = (price, currencies, currency) => {
    const convertedPrice = {
        amount: {
            withDecimal: price.amount.toFixed(2),
            withoutDecimal: Math.round(price.amount),
        },
        currency: price.currencyCode,
    };
    if (!currencies || !currencies.exchangeRates.length || !currency) {
        return convertedPrice;
    }
    const currentCurrency = currencies.exchangeRates.find(rate => rate.code === price.currencyCode);
    if (!currentCurrency) {
        return convertedPrice;
    }
    const targetCurrency = currencies.exchangeRates.find(rate => rate.code === currency);
    if (!targetCurrency) {
        return convertedPrice;
    }
    const convertedAmount = Math.round((100 * parseFloat(targetCurrency.rate) * price.amount) /
        parseFloat(currentCurrency.rate)) / 100;
    convertedPrice.amount.withDecimal = convertedAmount.toFixed(2);
    convertedPrice.amount.withoutDecimal = Math.round(convertedAmount);
    convertedPrice.currency = currency;
    return convertedPrice;
};
exports.convertCurrency = convertCurrency;
